export enum CustomPaths {
  Signup = '/signup',
  SignupCompany = '/signup-company',
  ConfirmEmail = '/confirm-email/:id',
  PasswordRecovery = '/password-recovery',
  PasswordCreation = '/create-password',
  SsoAuth = '/oauth',
  Logout = '/logout',
}

export enum Paths {
  ClubProfile = '/club-profile',
  Clubs = '/groups',
  Academy = '/academy',
  Billing = '/billing',
  Groups = '/groups',
}

export const UnprotectedRoutes = {
  [CustomPaths.Signup]: CustomPaths.Signup,
  [CustomPaths.PasswordRecovery]: CustomPaths.PasswordRecovery,
  [CustomPaths.Logout]: CustomPaths.Logout,
};
